import React from 'react';
import { ArrowLeft, Sparkles } from 'lucide-react';

const AuthPage = ({
  authView,
  setAuthView,
  error,
  setError,
  success,
  setSuccess,
  loading,
  loginForm,
  setLoginForm,
  registerForm,
  setRegisterForm,
  forgotPasswordEmail,
  setForgotPasswordEmail,
  resetPasswordForm,
  setResetPasswordForm,
  handleLogin,
  handleRegister,
  handleForgotPassword,
  handleResetPassword
}) => {
  return (
    <div className="app-container">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <img src="/plate-planner-pro-logo.webp" alt="Plate Planner Pro" />
          </div>
          <h1>Plate Planner Pro</h1>
          <p className="auth-subtitle">Professional meal planning for fitness coaches</p>
          
          {/* Tab Switcher */}
          <div className="auth-tabs">
            <button 
              className={`auth-tab ${authView === 'login' ? 'active' : ''}`}
              onClick={() => setAuthView('login')}
            >
              Log In
            </button>
            <button 
              className={`auth-tab ${authView === 'register' ? 'active' : ''}`}
              onClick={() => setAuthView('register')}
            >
              Sign Up
            </button>
          </div>
          
          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}
          
          {authView === 'login' ? (
            <form onSubmit={handleLogin} className="auth-form">
              <div className="form-group">
                <input
                  type="email"
                  value={loginForm.email}
                  onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
                  required
                  placeholder="Email address"
                  data-testid="login-email"
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                  required
                  placeholder="Password"
                  data-testid="login-password"
                />
              </div>
              <button type="submit" className="btn-auth-primary" disabled={loading} data-testid="login-submit">
                {loading ? 'Signing in...' : 'Log In'}
              </button>
              <button 
                type="button" 
                className="btn-link forgot-password-link"
                onClick={() => { setAuthView('forgot-password'); setError(null); setSuccess(null); }}
              >
                Forgot your password?
              </button>
            </form>
          ) : authView === 'register' ? (
            <form onSubmit={handleRegister} className="auth-form">
              <div className="form-group">
                <input
                  type="text"
                  value={registerForm.name}
                  onChange={(e) => setRegisterForm({ ...registerForm, name: e.target.value })}
                  required
                  placeholder="Full name"
                  data-testid="register-name"
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  value={registerForm.email}
                  onChange={(e) => setRegisterForm({ ...registerForm, email: e.target.value })}
                  required
                  placeholder="Email address"
                  data-testid="register-email"
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  value={registerForm.password}
                  onChange={(e) => setRegisterForm({ ...registerForm, password: e.target.value })}
                  required
                  placeholder="Password"
                  minLength={6}
                  data-testid="register-password"
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  value={registerForm.confirmPassword}
                  onChange={(e) => setRegisterForm({ ...registerForm, confirmPassword: e.target.value })}
                  required
                  placeholder="Confirm password"
                  data-testid="register-confirm-password"
                />
              </div>
              <button type="submit" className="btn-auth-primary" disabled={loading} data-testid="register-submit">
                {loading ? 'Creating account...' : 'Sign Up'}
              </button>
            </form>
          ) : authView === 'forgot-password' ? (
            <form onSubmit={handleForgotPassword} className="auth-form">
              <h3 className="auth-form-title">Reset Password</h3>
              <p className="auth-form-subtitle">Enter your email and we'll send you a reset link.</p>
              <div className="form-group">
                <input
                  type="email"
                  value={forgotPasswordEmail}
                  onChange={(e) => setForgotPasswordEmail(e.target.value)}
                  required
                  placeholder="Email address"
                  data-testid="forgot-email"
                />
              </div>
              <button type="submit" className="btn-auth-primary" disabled={loading} data-testid="forgot-submit">
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <button 
                type="button" 
                className="btn-link back-to-login"
                onClick={() => { setAuthView('login'); setError(null); setSuccess(null); }}
              >
                <ArrowLeft size={14} style={{marginRight: '4px'}} /> Back to Login
              </button>
            </form>
          ) : authView === 'reset-password' ? (
            <form onSubmit={handleResetPassword} className="auth-form">
              <h3 className="auth-form-title">Set New Password</h3>
              <p className="auth-form-subtitle">Enter your new password below.</p>
              <div className="form-group">
                <input
                  type="password"
                  value={resetPasswordForm.newPassword}
                  onChange={(e) => setResetPasswordForm({ ...resetPasswordForm, newPassword: e.target.value })}
                  required
                  placeholder="New password"
                  minLength={6}
                  data-testid="reset-password"
                />
              </div>
              <div className="form-group">
                <input
                  type="password"
                  value={resetPasswordForm.confirmPassword}
                  onChange={(e) => setResetPasswordForm({ ...resetPasswordForm, confirmPassword: e.target.value })}
                  required
                  placeholder="Confirm new password"
                  data-testid="reset-confirm-password"
                />
              </div>
              <button type="submit" className="btn-auth-primary" disabled={loading} data-testid="reset-submit">
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          ) : null}
          
          <div className="auth-trial-info">
            <p className="trial-highlight"><Sparkles size={16} style={{marginRight: '6px'}} /> Try us out for free!</p>
            <p className="trial-price">No card needed.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
